import remarkHtml from 'remark-html'
import remarkParse from 'remark-parse'
import { unified } from 'unified'

/**
 * Converts markdown to it's HTML equivalent. Does not do any sanitizing.
 *
 * @param markdown Markdown input as a string
 */
export default function convertMarkdownToHtml(markdown: string): string {
  return unified()
    .use(remarkParse)
    .use(remarkHtml, { sanitize: false })
    .processSync(markdown)
    .toString()
}
